export const MAPBOX_ACCESS_TOKEN = process.env.NEXT_PUBLIC_MAP_ACCESSTOKEN;

export const SOURCES = {
	earthquakes: 'earthquakes',
	route: 'route'
};

export const DEFAULT_ZOOM = 18;

export const TAB_COLORS = {
	active: '#F3F3F3',
	inactive: '#727272'
};

export const MINI_MAP_TABS = {
	checkpoint: 1,
	map: 2,
	userDrive: 3
};

export const MAP_DATA_SOURCE = {
	geofences: 'geofences',
	botLocation: 'botLocation'
};

export const GEOFENCE_ALERT_MODES = {
	safe_zone: {
		name: 'safe_zone',
		color: '#008000'
	}
};
